<template>
  <v-col lg="6" md="6" sm="10" cols="12">
    <v-card>
      <v-text-field outlined class="pt-8 ml-2 mr-2" dense v-model="serverAddress" label="Адрес на ZFPLabServer" placeholder="http://localhost:4444/ - по подразбиране" required :rules="requiredRule"></v-text-field>
      <v-row justify="center">
        <v-alert v-if="errorMessage" border="top" colored-border type="warning" elevation="1" dense class="ml-2 mr-2" dismissible>
          <span>{{ errorMessage }}</span>
        </v-alert>
      </v-row>
      <v-row justify="end">
        <v-btn class="mr-6 mb-4" tile :color="isInDarkMode ? '' : 'blue lighten-4'" @click="connectToLabServer">
          <v-icon color="#1685c9">mdi-power-plug</v-icon>
          <span>Свързване</span>
        </v-btn>
      </v-row>
    </v-card>
  </v-col>
</template>

<script>
import Const from "../constants";
// import Tremol from "../assets/fp/fp"

export default {
  props: {},
  data() {
    return {
      errorMessage: "",
      serverAddress: "http://localhost:4444/",
      requiredRule: [v => !!v || "Задължително поле!"]
    };
  },
  methods: {
    isOnHttps() {
      return window.location.protocol == "https:";
    },
    async connectToLabServer() {
      if (this.serverAddress == "") {
        this.serverAddress = "http://localhost:4444/";
      }
      localStorage.setItem(Const.ZFPLabServerAddress, this.serverAddress);
      await this.fp.ServerSetSettings(this.serverAddress);
      this.fp.isSearchingForServer = true;
      setTimeout(async () => {
        try {
          var err = await this.fp.checkServerVersionGetError();
          if (err != null) {
            this.fp.isSearchingForServer = false;
            this.fp.setErrorMessage(err);
            return;
          }
          this.fp.isConnectedToServer = true;
        } catch (ex) {
          this.fp.setErrorMessage("Неуспешна връзка с " + this.serverAddress);
          this.fp.isConnectedToServer = false;
        }
        this.fp.isSearchingForServer = false;
      }, 300);
    }
  },
  mounted() {
    var addr = localStorage.getItem(Const.ZFPLabServerAddress);
    if (addr) {
      this.serverAddress = addr;
    }
  }
};
</script>

<style>
input:placeholder-shown {
  padding-left: 5px;
  font-size: 0.8em;
}
</style>
